export default "__VITE_ASSET__CGtqWaYV__"